import { render, staticRenderFns } from "./TestRunIndex.vue?vue&type=template&id=2fc0a319"
import script from "./TestRunIndex.vue?vue&type=script&lang=js"
export * from "./TestRunIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports